<div class="container">
    <div class="row mt-3" style="justify-content: center;">
        <div class="col col-sm-12 col-md-12 col-lg-12">
            <h2>{{ 'credit.credits' | translate }}</h2>
        </div>
    </div>
    <div class="row mt-3" style="justify-content: center;">
        <div class="col col-sm-12 col-md-12 col-lg-12">
            <h1>{{ 'credit.currentBalance' | translate }}: {{ mainService.balance?.CurrentCreditAmount | currency }}</h1>
        </div>
    </div>
    <div class="row mt-2" style="justify-content: center;">
        <div class="col col-sm-12 col-md-12 col-lg-12">
            <form [formGroup]="form">
                <input type="text" name="first-name" card-name style="display: none;" />
                <div class="card-container d-none">
                </div>
                <div class="row mb-3">
                    <div class="col col-sm-12 col-md-6 col-lg-6">
                        <mat-form-field appearance="outline">
                            <mat-label>{{'credit.quantity' | translate}} *</mat-label>
                            <input matInput type="number" min="1" formControlName="Quantity"/>
                            <mat-error *ngIf="form.controls['Quantity'].hasError('required')">
                                {{'payment.cardError' | translate}}
                            </mat-error>
                            <mat-error *ngIf="form.controls['Quantity'].hasError('pattern')">
                                {{'credit.patternError' | translate}}
                            </mat-error>
                            <mat-error *ngIf="form.controls['Quantity'].hasError('min')">
                                {{'credit.minQuantityError' | translate}}
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col col-sm-12 col-md-6 col-lg-6">
                        <mat-form-field appearance="outline">
                            <mat-label>{{'payment.nameOnCard' | translate}} *</mat-label>
                            <input matInput type="text" formControlName="NameOnCard"/>
                            <mat-hint class="materialize-red-text"
                            [hidden]="!form.controls.NameOnCard.errors || !form.controls.NameOnCard.touched==true ">
                            {{'payment.cardError' | translate}}</mat-hint>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row mb-2">
                    <div class="col col-sm-12 col-md-6 col-lg-6">
                        <div class="mb-3">
                            <app-credit-card-selector></app-credit-card-selector>
                        </div>
                        <mat-form-field appearance="outline">
                            <mat-label>{{'payment.cardNumber' | translate}} *</mat-label>
                            <input matInput type="tel" name="number"
                                formControlName="CardNumber" (input)="formatValue($event)"/>

                            <mat-hint   class="materialize-red-text"
                                        *ngIf="cardFormatterService.cardType=='Unknown' || form.controls.CardNumber.errors"
                                        [hidden]="!form.controls.CardNumber.touched==true">
                                    {{'payment.cardError' | translate}}</mat-hint>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row">
                    <div class="col col-sm-12 col-md-6 col-lg-4">
                        <div class="form-group">
                            <mat-form-field appearance="outline">
                                <mat-label>{{'payment.expiry' | translate}} (MM/YYYY) *</mat-label>
                                <input matInput type="text" name="expiry" formControlName="Expiry" mask="00 / 0000" [dropSpecialCharacters]="false" />
                                <mat-hint   class="materialize-red-text"
                                            [hidden]="!form.controls.Expiry.errors || !form.controls.Expiry.touched==true">
                                    {{'payment.expError' | translate}}
                                </mat-hint>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="col col-sm-12 col-md-3 col-lg-2">
                        <div class="form-group">
                            <mat-form-field appearance="outline">
                                <mat-label>CVC *</mat-label>
                                <input matInput type="text" name="cvc" formControlName="CVC" (keypress)="numberOnly($event)" maxlength="4" minlength="3"/>
                            </mat-form-field>
                        </div>
                    </div>
                </div>
                <div class="row mb-2">
                    <div class="col col-sm-12 col-md-12 col-lg-12">
                        <h3 class="border-bottom">{{ 'payment.address' | translate }}</h3>
                        <app-street-postal-address-form 
                            formControlName="PaymentAddress" 
                            [showHeaders]="false" 
                            [managePostal]="false" 
                            [isRequired]="true">
                        </app-street-postal-address-form>
                    </div>
                </div>
            </form>
        </div>

        <div class="col col-sm-12 col-md-12 col-lg-12">
            <div class="d-flex">
            <div class="mr-2">
                <button mat-button
                        class="btn-size"
                        color="primary"
                        [disabled]="!form.valid || isSaving() ||
                                    paymentType=='Unknown'"
                        (click)="tryPay()">
                    <ng-container *ngIf="!isSaving()">
                        {{'credit.buy' | translate}}
                        <mat-icon>send</mat-icon>
                    </ng-container>
                    <ng-container *ngIf="isSaving()">
                        <div  class="d-flex align-items-center justify-content-center spinner-wht">
                        <mat-spinner [diameter]="20" class="button-spinner"></mat-spinner>
                        </div>
                    </ng-container>
                </button>
            </div>
            <div class="mr-2">
                <button mat-button
                        color="primary"
                        (click)="close()">
                    {{'credit.cancel' | translate}}
                </button>
            </div>
            </div>
        </div>
    </div>
    <div class="row" *ngIf="serverError!=''">
        <div class="col col-sm-12">
          <div class="server-error h4">{{this.serverError}}</div>
        </div>
    </div>
    <div class="mb-5"></div>
    <ng-template #terms>
    </ng-template>
</div>
